import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export const Indicator = styled.svg.attrs({
  viewBox: '0 1 10 9',
})`
  width: inherit;
  height: inherit;
  stroke-dashoffset: 1;
`;

export const Stroke = styled.path.attrs({
  d: 'M2 8 A 4 4 0 1 1 8 8',
})`
  fill: none;
  stroke: #dbdbdb;
  stroke-width: 1.5;
  transition: stroke-dasharray 0.3s linear;
  stroke-linecap: round;

  ${props => props.progress && `
    stroke-dasharray: 0 20;
    stroke-dashoffset: 0.9;
    height: 20px;
    margin-bottom: 20px;
    overflow: hidden;
    background-color: #f5f5f5;
    border-radius: 4px;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1);
  `};
`;

export const ActiveStroke = styled(Stroke).attrs({
  progress: true,
})`
  stroke: ${props => (props.isClient
    ? props.theme.colors.completed
    : props.theme.colors.successLight)};
  stroke-dasharray:  ${props => props.percentage || 0} 20;
`;

export const Content = styled(Flex).attrs({
  align: 'center',
  column: true,
  spacing: 8,
})`
  position: absolute;
  top: 45px;
  width: 90px;
`;
